module.exports = __webpack_public_path__ + "img/08.353710f7.png";